// extracted by css-extract-rspack-plugin
export default {"spaceXXSmall":"4px","container":"tanstack-query-devtools__container___WJp83"};